<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{ title }}</div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Bedingung wählen">
          <multiselect v-model="selectedCondition" :show-labels="false" placeholder="Bedingung auswählen"
                       :options="conditions" :multiple="false" track-by="id" label="name"
                       :close-on-select="true"></multiselect>
        </b-field>
      </div>

    </div>
    <RuleConditionPackageAndQuantity v-if="!loading && selectedCondition.id==1" :item="item"
                                     @setConditionData="setConditionData"/>
    <RuleDateInterval v-if="!loading && selectedCondition.id==2" :item="item" @setConditionData="setConditionData"/>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Aktion wählen">
          <multiselect v-model="selectedAction" :show-labels="false" placeholder="Aktion auswählen"
                       :options="actions" :multiple="false" track-by="id" label="name"
                       :close-on-select="true"></multiselect>
        </b-field>
      </div>
    </div>
    <RuleActionShowText v-if="!loading &&  selectedAction.id==1" :item="item" @setActionData="setActionData"/>
    <RuleActionIncreasePrice v-if="!loading &&  selectedAction.id==2" :item="item" @setActionData="setActionData"/>

    <div class="columns">
      <div class="column">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src

import Multiselect from "vue-multiselect";
import RuleConditionPackageAndQuantity from "@/components/RuleConditionPackageAndQuantity.vue";
import RuleDateInterval from "@/components/RuleDateInterval.vue";
import RuleActionShowText from "@/components/RuleActionShowText.vue";
import RuleActionIncreasePrice from "@/components/RuleActionIncreasePrice.vue";

const axios = require('axios');


export default {
  name: "SingleUser",
  components: {
    RuleActionIncreasePrice,
    RuleDateInterval,
    RuleActionShowText,
    Multiselect,
    RuleConditionPackageAndQuantity
  },
  data() {
    return {
      selectedCondition: {"id": 1, "name": "Stückzahl und Verpackung"},
      allConditions: [{"id": 1, "name": "Stückzahl und Verpackung"}, {"id": 2, "name": "Datums-Interval und Aufschlagsatzstaffel"}],
      conditions: [],
      selectedAction: {"id": 1, "name": "Text anzeigen"},
      allActions: [{"id": 1, "name": "Text anzeigen"}, {"id": 2, "name": "Preis erhöhen"}],
      allowedCombinations: {1: [1], 2: [2]},
      actions: [],
      title: "Neue Regel anlegen",
      item: {},
      loading: true,
      //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
    }
  },
  watch: {
    selectedCondition: {
      handler: "selectCondition"
    },
    selectedAction: {
      handler: "selectAction"
    },
  },
  mounted: function () {
    this.conditions = this.allConditions
    this.actions = this.allActions
    console.log("FORM " + this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Regel bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/rules/' + this.$route.params.id, {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.item = response.data;
            if (_this.item.type==1) {
              _this.selectedCondition=_this.allConditions[0]
            } else  if (_this.item.type==2) {
              _this.selectedCondition=_this.allConditions[1]
            }
            if (_this.item.actions[0].type==1) {
              _this.selectedAction=_this.allActions[0]
            } else  if (_this.item.actions[0].type==2) {
              _this.selectedAction=_this.allActions[1]
            }
            _this.loading = false;

          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    } else {
      this.loading = false;
      this.item.data = {}
    }

  },
  methods: {
    selectCondition: function () {
      console.log("selectCondition")
      // select allowed actions only
      this.actions = this.allActions.filter(el => {
            let allowedActions = this.allowedCombinations[this.selectedCondition.id]
            return allowedActions.includes(el.id)
          }
      )
      // Select another action if it is not an allowed combination
      if (!this.actions.includes(this.selectedAction)) {
        this.selectedAction = this.actions[0]
      }
    },
    selectAction: function () {
      // console.log("selectAction")
    },
    setConditionData: function (msg) {
      console.log("receivedConditionDataFromChild:")
      console.log(msg)
      this.item.type = msg.type
      if (msg.type==1) {
        this.item.data.package_code_contains = msg.package_code_contains
        this.item.data.quantity_bg = msg.quantity_bg
        this.item.data.quantity_sm_eq = msg.quantity_sm_eq
      } else if (msg.type==2) {
        this.item.data.extraChargeId = msg.extraChargeId
        this.item.data.selectedDayFrom = msg.selectedDayFrom
        this.item.data.selectedMonthFrom = msg.selectedMonthFrom
        this.item.data.selectedDayTo = msg.selectedDayTo
        this.item.data.selectedMonthTo = msg.selectedMonthTo
      }
    },
    setActionData: function (msg) {
      console.log("receivedActionDataFromChild:")
      console.log(msg)
      this.item.actions = [msg]
    },
    save: function () {
      //Set-Package
      var _this = this;
      var url = '/api/rules';


      console.log("SAVE");
      console.log(url);
      console.log(this.item);

      axios.post(url, this.item, {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.$router.push({name: 'rules'})
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });


    }
  }
};

</script>
